import { FormControlModel } from '../../risk-distribution/config/risk-distribution-form-controls.config';

export const DESCRIPTION_CONTROLS: FormControlModel[] = [
  {
    key: 'name',
    label: 'formulaManagement.formulaName',
    controlType: 'textfield',
    position: 0,
    required: true,
    maxLength: 50
  },
  {
    key: 'targetType',
    label: 'formulaManagement.targetType',
    controlType: 'dropdown',
    value: 'ALL',
    position: 1
  },
  {
    key: 'status',
    label: 'formulaManagement.status',
    controlType: 'dropdown',
    value: 'DRAFT',
    position: 2
  },
  {
    key: 'rounding',
    label: 'formulaManagement.roundRiskBands',
    controlType: 'radio',
    fullRow: true,
    position: 5,
    value: false
  },
  {
    key: 'description',
    label: 'formulaManagement.description',
    controlType: 'textarea',
    fullRow: true,
    position: 6,
    placeHolder: 'formulaManagement.descriptionPlaceholder',
    maxLength: 4096
  }
];

export const EDIT_DESCRIPTION_CONTROLS = [
  {
    key: 'lastUpdateDateString',
    label: 'formulaManagement.updatedDate',
    controlType: 'readonly',
    position: 3
  },
  {
    key: 'lastUpdatedBy',
    label: 'formulaManagement.updatedBy',
    controlType: 'readonly',
    position: 4
  }
];
